function RollUpSvg(className = 'default') {
  return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M10.5 3L6 6L10.5 9" stroke="#676767" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M6 3L1.5 6L6 9" stroke="#676767" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
  )
};

export default RollUpSvg;